import { Component, OnInit } from '@angular/core';
import { RewardProvider } from "../../shared/providers/rewards.provider";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';

@Component({
  selector: 'app-reward-categories',
  templateUrl: './reward-categories.component.html',
  styleUrls: ['./reward-categories.component.scss']
})

export class RewardCategoriesComponent implements OnInit {

  addOrEditRewardCategory: string;
  formGroup;
  deletePopupUiData;
  constructor(
    public rewardProviders: RewardProvider,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public adminDataProvider: AdminDataProvider,

  ) { }
  rewardCategories = []
  ngOnInit() {
  }

  ngDoCheck() {
    this.rewardCategories = this.rewardProviders.rewardCategory;
    console.log('works?', this.rewardCategories);
  }

  addRewardCategory(targetModal) {
    this.addOrEditRewardCategory = "add";
    this.formGroup = this.fb.group({
      category_name: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      hassubcategories: new FormControl("", [Validators.required]),
      category_order:  new FormControl("", [Validators.pattern('^[0-9]*$')]),
      program_id: 1,
    });

    this.showRewardCategoryModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editRewardCategory(targetModal, rewardInfo) {
    this.addOrEditRewardCategory = "edit";
    this.formGroup = this.fb.group({
      id: rewardInfo.id,
      category_name: new FormControl(rewardInfo.category_name, [Validators.required]),
      description: new FormControl(rewardInfo.description, [Validators.required]),
      hassubcategories: new FormControl(rewardInfo.hassubcategories, [Validators.required]),
      category_order:  rewardInfo.category_order,
      program_id: 1,
    });

    this.showRewardCategoryModal(targetModal);
  }

  deleteRewardCategory(targetModal, rewardInfo){
    this.addOrEditRewardCategory = "delete";
    this.deletePopupUiData = rewardInfo.category_name;
    this.formGroup = this.fb.group({
      id: rewardInfo.id,
      program_id: 1,
    });
    this.showRewardCategoryModal(targetModal);
  }



  showRewardCategoryModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitRewardCategory(formData) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    if (this.addOrEditRewardCategory == "add") {
      this.rewardProviders.addRewardCategoryList(formData);
      this.modalService.dismissAll();
    } else if (this.addOrEditRewardCategory == "edit") {
      this.rewardProviders.editRewardCategoryList(formData);
      this.modalService.dismissAll();
    } else if (this.addOrEditRewardCategory == "delete") {
      this.rewardProviders.deleteRewardCategoryList(formData);
      this.modalService.dismissAll();
    }
    this.submitted = false;
  }

}
